import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import useDarkMode from 'use-dark-mode';

const NavStyles = styled.nav`
  ul {
    height: 63px;
    width: 100%;
    padding: 0 calc(6.5% / 3);
    border-bottom: 1.2px solid var(--border-color);
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    li:nth-of-type(2) {
      margin-left: auto;
    }

    li:nth-of-type(n + 3) {
      margin-left: 3rem;

      @media (max-width: 420px) {
        margin-left: 2rem;
      }
    }

    @media (min-width: 2000px) {
      height: 99px;
    }

    @media (max-width: 374px) {
      li:nth-of-type(4) {
        display: none;
      }
    }
  }
  a {
    display: block;
    text-decoration: none;
  }
`;

const IconStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 4rem;
  }

  @media (min-width: 2000px) {
    svg {
      width: 6rem;
    }
  }
`;

export default function Nav() {
  const darkMode = useDarkMode(false);

  function toggleTheme(e) {
    e.preventDefault();
    darkMode.toggle();
  }

  return (
    <NavStyles>
      <ul>
        <li>
          <Link to="/" aria-label="home">
            Nathan Ceddia
          </Link>
        </li>
        <li>
          <Link to="/contact" aria-label="contact">
            <IconStyles>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 798.88 590.81"
              >
                <g id="handshake-icon" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <g id="Page-1">
                      <g id="_handshake" data-name=" handshake">
                        <path
                          id="Shape"
                          d="M345.35,544.65a20,20,0,1,0-40,0c0,10.8,9.2,20.2,19.8,20.2A20.34,20.34,0,0,0,345.35,544.65Zm-135-95.1a20.1,20.1,0,1,0,40.2.1c.1-10.7-9.6-20.6-20-20.7C220,429,210.45,438.75,210.35,449.55Zm87.3-157.2c9.4,14.1,27.2,16.2,39.4,4.3,22.8-22.5,45.3-45.2,68.1-67.7a19.79,19.79,0,0,1,6.8-4.7,12.87,12.87,0,0,1,15,4.7c3.4,5.1,3,11.2-1.4,16-3.8,4.2-7.9,8.3-11.9,12.4,11.8,12.9,24.2,24.1,39,32.2,15.8,8.7,32,13.7,50.2,6.9,6.8-2.6,13.2,1.7,15.6,8.6,2.2,6.4-.6,12.4-7.2,15.5a29,29,0,0,1-7,2.4c-6.9,1.2-13.9,2.1-20,3q38.55,38.4,78.8,78.6c1.6-1.8,3.8-4.5,6.3-6.9,26-25.7,42.8-56.4,49.8-92.3,2.5-12.8,7.5-24.3,16.8-33.7,7.9-7.9,15.8-15.7,23.6-23.5,4.9-4.9,9.7-9.8,14.2-14.4-34.8-34.8-69-69.1-104.2-104.4-5.7,6.1-11.2,12.6-17.4,18.2-20,18.3-43.2,22.4-68.7,13.8-8-2.6-15.7-6.5-23.9-7.8-28.4-4.5-53.6,3.1-74.3,23.4-18.1,17.7-35.8,35.7-53.6,53.6-10.1,10.1-20.3,20.2-30.3,30.4C292.45,269.75,291.15,282.55,297.65,292.35ZM279,517.85c10.8,0,19.5-9,19.6-20.1,0-10.9-9.2-21.2-19.9-20.6-11,.7-19.9,7.5-20.2,20.8C258.15,509,267.75,517.85,279,517.85Zm-137.2-250.8c12,10.9,18.7,24.5,21.8,40.3,7.5,38.1,26.8,69.6,55.2,95.8a5.45,5.45,0,0,0,4.2,1c22.1-3,43.5,8.3,51,30.5,1.8,5.4,2.2,11.2,3.3,16.8a7.72,7.72,0,0,0,1.5.2c26.8.2,45.4,21.9,45.6,43.3,0,3,1.5,3.7,4.4,3.9,19,1.3,32.4,11,39.3,28.7,2.8,7.1,3.1,15.1,4.8,23.5,9.5,2.9,21.8-9.8,17.8-20.7-1.7-4.6-5.1-8.8-8.6-12.4-26.1-26.4-52.5-52.5-78.6-78.8a15.57,15.57,0,0,1-3.8-7.3,12.25,12.25,0,0,1,6.5-13.8,13.81,13.81,0,0,1,15.6,2.9c12.7,12.6,25.3,25.3,38,37.9q36.3,36.3,72.5,72.4c6.3,6.3,13.7,8.1,20.3,5,11.8-5.5,13.9-19.2,4.3-28.9q-35-35-69.9-69.8c-10.7-10.7-21.5-21.3-32.1-32.1-6.8-7-5.1-17.4,3.2-21.3,5.3-2.5,11-1.1,16.2,4.1l66.3,66.3L497,511c4.2,4.2,9.1,7.8,15.1,7.2,7.5-.8,13.2-4.8,15.6-12.6,2.2-7.3-.5-12.8-5.6-17.9-8.6-8.5-17.1-17.2-25.6-25.7q-52.65-52.5-105.2-105.1c-6.1-6.1-6.5-14.2-1.2-19.4,5.7-5.5,13.6-5,19.8,1.3,10.8,10.8,21.6,21.5,32.4,32.3,29.6,29.6,59.1,59.2,88.8,88.6a23.26,23.26,0,0,0,10.6,5.9c7.5,1.6,14.5-2.4,17.8-8.9,3.6-7.2,2.3-14.4-3.7-20.5q-66.15-66-132.2-132.1c-9.4-9.4-18.7-18.8-28.2-28.5-1.6,1.5-2.8,2.6-4,3.8-12,12-23.8,24.1-35.9,35.9a51.14,51.14,0,0,1-57.8,9.8c-32.7-15.1-39.9-57.3-14.3-83,24.2-24.4,48.7-48.6,73-72.9,1.3-1.3,2.5-2.7,4.7-5-9.4,2.3-17,5.1-25,6-20.8,2.3-39.3-3.5-54.3-18.6-10.3-10.4-20.4-21.1-30.2-31.2-43.6,43.3-85.8,85.5-128.9,128.6C128.85,254.85,135.15,261.05,141.75,267.05Zm-40.6,2.1c-7.3,7-13.9,7.2-21.2.1-11.2-10.9-22.1-22-33.1-33-13.8-13.9-27.7-27.7-41.5-41.6-7.2-7.2-7.1-13.9.1-21.1Q89.9,89.1,174.15,4.55c6.3-6.3,16.8-5.8,22.4-.1,24,24.6,48.5,48.6,72.8,72.9,8.6,8.6,8.7,13.8.8,23.1-.4.5-.7,1.1-1.5,2.3,12.5,12,24.7,24.4,37.7,35.8,6.4,5.6,15.1,7.7,23.7,6.8,5.8-.6,11.6-2.6,17.2-4.2a82.52,82.52,0,0,1,40.7-1.9,12.35,12.35,0,0,0,7.5-1.2,121.45,121.45,0,0,1,39.4-10.8c20-1.9,38.6,2,56.9,9.5,14.1,5.8,27.5,4,39.2-5.4,7.4-6,13.6-13.5,21.5-21.5a70,70,0,0,1-7.4-5.8c-5.7-5.8-5.8-13.7,0-19.5,25.3-25.4,50.8-50.8,76.2-76.1,6.4-6.3,13.8-5.9,20.5.8q57,56.85,113.9,113.9c12.6,12.6,25.2,25.1,37.8,37.7,7.3,7.3,7.2,14.2-.1,21.6q-36.45,36.45-72.9,72.8c-8.7,8.7-15.4,8.7-24.2,0-1-1-2.1-2-4.1-3.8-6.8,7-13.3,14-20,20.8-5.6,5.7-11.2,11.4-17,16.8-7.9,7.5-9.7,17.4-11.9,27.3-8.2,37.1-25.9,69-52.3,96.2-2.8,2.9-5.5,5.8-8.5,8.4-2.3,2.1-2.6,3.8-1,6.7,11.9,21.9,4.7,47-16.9,59.1-.4.2-.8.8-1.2.8-9.7,1-9.8,7-9.5,15,.6,19.2-14.8,36.4-33.4,40.3-10.5,2.2-22.4.4-34-6.3a44.27,44.27,0,0,1-71.1,15.2c-5.2,5.7-9.8,11.9-15.6,16.9-10.5,9-23.3,9.3-36.3,7.4-1.6-.2-3.9,0-5,1-14.7,13.6-31.7,17.3-49.8,10.3-18.3-7-28.1-21.5-29.3-41.3a5.84,5.84,0,0,0-.4-1.8c-31.2-5-43.4-17.5-46.9-48.5-19.3-.5-34.9-8.2-43.3-26.5-8.3-18.1-5.1-35.2,7.6-51.2L186.15,407c-25.4-27.9-41.5-60.4-48.9-97.5a43.66,43.66,0,0,0-8.9-18.5c-7.2-8.8-15.9-16.3-24.1-24.6C103.05,267.45,102.05,268.25,101.15,269.15Zm606.4-39.1,58.6-58.6q-67.5-67.5-135.7-135.8c-18.1,18.1-36.2,36.3-54.6,54.4-3.2,3.1-3.4,4.9-.1,8.2q49.2,48.75,98,97.8C685.25,207.45,696.55,219,707.55,230.05ZM243.25,89.15c-19.2-19.2-38.6-38.6-57.7-57.8L32.65,184.25,90.35,242Q167,165.45,243.25,89.15Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </IconStyles>
          </Link>
        </li>
        <li>
          <a href="/" onClick={toggleTheme}>
            {darkMode.value ? 'Light Mode' : 'Dark Mode'}
          </a>
        </li>
      </ul>
    </NavStyles>
  );
}
